/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-desc[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{display:block;margin-top:15px}tr.cdk-drag-preview[_ngcontent-%COMP%]{display:none}"];
export { styles as styles };
